import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import {
  ADFOX_SPECIAL_PROJECT_CARD_SIZE,
  ADFOX_SPECIAL_PROJECT_P_PARAMS,
  getAdfoxSpecialProjectPlace,
} from '../../../constants/adfoxSpecialProject';

import type { TAdBannerPlaceParameters } from '../../AdBannerMicrofrontendContainer';

/**
 * Параметры места «adfox-баннер спецпроекта на карте».
 *
 * place/pParams берём из общих с легаси-баннером констант, чтобы микрофронтенд запрашивал
 * ровно то же размещение. sizes — размер карточки, а не контейнера adfox: микрофронтенд
 * рисует баннер по `sizes`, тогда как легаси-шаблон задавал размер своей вёрсткой. Девайс задаём явно: размеры и площадка у десктопа
 * и мобилки разные, адаптив микрофронтенда здесь не подходит.
 */
export function useSpecialProjectParameters(developerId: number): TAdBannerPlaceParameters {
  const deviceType = useDeviceType();

  return React.useMemo<TAdBannerPlaceParameters>(
    () => ({
      place: getAdfoxSpecialProjectPlace(deviceType, developerId),
      pParams: ADFOX_SPECIAL_PROJECT_P_PARAMS[deviceType],
      sizes: ADFOX_SPECIAL_PROJECT_CARD_SIZE[deviceType],
      position: null,
      galleryPosition: null,
      // Легаси-баннер отдаёт в postview-аналитику только place, поле isSp остаётся undefined
      // и уезжает в teaser-событие как false. Держим false и здесь, иначе при включении флага
      // тот же баннер начнёт помечаться спецпроектом и данные разъедутся с легаси.
      isSp: false,
      tgbNativedescGeneralDesign: null,
      carousel: null,
      deviceType,
    }),
    [deviceType, developerId],
  );
}
